export class UploadFileINModel {
    note: string;
    file: Blob;
    idProgetto: number;
    idFolderTree: number;
}
